import { notFound } from '@tanstack/react-router';

/** O maior código que cabe no `int` da API. */
export const MAXIMO_CODIGO = 2_147_483_647;

/**
 * O código ou id do cliente na url. Qualquer outra coisa, ou um valor acima do `maximo`, é página
 * inexistente.
 */
export function parseIdCliente(
  valor: string,
  maximo = Number.MAX_SAFE_INTEGER,
) {
  const id = Number(valor);

  if (!/^[1-9]\d*$/.test(valor) || id > maximo) {
    throw notFound();
  }

  return id;
}
